import React from "react";

export const Label = ({ children }: { children: string }) => {
  return <label className="text-black text-sm">{children}</label>;
};
